import { useState } from 'react';
import { RefreshCw } from 'lucide-react';

// Wraps a section and shows a floating refresh button.
// Refresh remounts the children, re-running their data fetching.
export const RefreshableSection = ({ children }) => {
  const [refreshKey, setRefreshKey] = useState(0);
  const [spinning, setSpinning] = useState(false);

  const handleRefresh = () => {
    setSpinning(true);
    setRefreshKey(k => k + 1);
    setTimeout(() => setSpinning(false), 900);
  };

  return (
    <>
      <div key={refreshKey} className="contents">{children}</div>
      <button
        onClick={handleRefresh}
        data-testid="section-refresh-button"
        title="Refresh"
        aria-label="Refresh section"
        className="fixed bottom-20 right-4 lg:bottom-6 lg:right-6 z-[60] h-12 w-12 rounded-full bg-slate-900 text-white shadow-xl border border-slate-700 flex items-center justify-center hover:bg-slate-700 active:scale-95 transition-colors"
      >
        <RefreshCw className={`h-5 w-5 ${spinning ? 'animate-spin' : ''}`} />
      </button>
    </>
  );
};
